var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13574 2.51343L4.83842 6.22829L9.70396 7.2188",
    stroke: "#EF6D58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1758 6.4209L22.0002 3.91984L18.7244 0.99991",
    stroke: "#EF6D58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2599 3.47439C16.7979 3.2341 9.05581 3.42633 5.78271 6.11758",
    stroke: "#EF6D58",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5027 29.7931L17.3884 29.3663C17.2511 28.8539 16.9159 28.4171 16.4565 28.1519L10.173 24.5241C8.88414 23.78 8.44255 22.1319 9.18666 20.8431V20.8431C9.93078 19.5543 11.5788 19.1127 12.8677 19.8568L15.2013 21.2041L12.8999 12.6151C12.5367 11.2598 13.341 9.86676 14.6963 9.50361V9.50361C16.0517 9.14045 17.4447 9.94475 17.8079 11.3001L19.123 16.208C19.123 16.208 27.3832 12.6796 28.8627 18.2011C30.3421 23.7226 28.5457 26.8341 28.5457 26.8341",
    stroke: "#585A5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeOrange);
export default __webpack_public_path__ + "static/media/swipeOrange.5f451385acc0860067f4a1755428565c.svg";
export { ForwardRef as ReactComponent };